import crud from '@/crud/index/index'
import components from './components'
import data from './data'
import methods from './methods'
import mounted from './mounted'
import computed from './computed'

export default {
  components,
  data,
  methods,
  mounted,
  computed,
  mixins: [crud],
  // se for perciso fazer auto serarch para trazer alguns registtros
  // mounted () {
  //   this.doLoad()
  // },
  resourcePath: 'v1/scheduling/see/schedules'
}



// WEBPACK FOOTER //
// ./src/app/patient/loading-page/gadget/resources/index.js